import React from 'react';
import { Col, Row } from 'react-bootstrap';

export interface IWidgetRowProps {
  label: string;
  value: React.ReactNode;
}

export const WidgetRow = (props: React.PropsWithChildren<IWidgetRowProps>): JSX.Element | null => {
  if ((!props.value && props.value !== 0) || (Array.isArray(props.value) && !props.value.length)) {
    return null;
  }

  return (
    <Row className="mb-2">
      <Col xs={4} className="text-muted">
        {props.label}
      </Col>
      <Col xs={8}>{props.value}</Col>
    </Row>
  );
};
